document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.querySelector('[type="application/json"][data-product-variants]');
  if (!dataEl) return;

  var variantData;
  try { variantData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function updateInventoryMessage(variantId) {
    var inventoryLabel = document.querySelector('.inventory-label');
    if (!inventoryLabel) return;
    var variant = variantData.find(function (v) { return v.id === variantId; });

    if (variant && variant.available && variant.inventory_quantity <= 1 && variant.inventory_quantity > 0) {
      var qty = variant.inventory_quantity;
      inventoryLabel.innerHTML = '<span class="inventory-dot-flex"></span>' + qty + ' item' + (qty > 1 ? 's' : '') + ' left in stock';
      inventoryLabel.style.display = 'block';
    } else {
      inventoryLabel.textContent = '';
      inventoryLabel.style.display = 'none';
    }
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest('label.block-swatch');
    if (!label) return;

    var selectedOption = label.dataset.value;
    var selectedSize = label.dataset.size;
    var matchedVariant = variantData.find(function (v) {
      return JSON.stringify(v.options) === JSON.stringify([selectedOption]);
    });
    if (!matchedVariant) return;

    setTimeout(function () {
      updateInventoryMessage(matchedVariant.id);

      var productForm = document.querySelector('[data-block-type="buy-buttons"] form');
      if (!productForm) return;

      var existingInput = productForm.querySelector('input[name="properties[size]"]');
      if (existingInput) existingInput.remove();

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[size]';
      input.value = selectedSize || selectedOption;
      productForm.appendChild(input);
    }, 500);
  });

  var initial = document.querySelector('[name="id"]');
  if (initial && initial.value) updateInventoryMessage(Number(initial.value));
});
